import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
// import { DeleteModalIcon } from '../../media/images/DeleteModalIcon';
import { useDispatch, useSelector } from 'react-redux';
import { NavigateFunction } from 'react-router-dom';
import warningLogo from '../../../../../../assets/warning.svg';
import styles from './RemoveScheduleConfirmationModalStyle.module.scss';
import { deleteScheduleByIdStart } from '../../redux/jobScheduleSlice';
import { RootState } from '../../../../../../redux/rootState';
import { setLoader } from '../../../../../../redux/loaderSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 539,
  height: 'auto',
  bgcolor: 'background.paper',
  borderRadius: '6px',
  boxShadow: 24,
  p: 5,
  '@media (max-width: 768px)': {
    width: '90%',
  },
};
type TypesConfirmModal = {
  show: boolean;
  setOpenFrom: () => void;
  callback: () => void;
  unitId: string;
  navigate: NavigateFunction;
  isScheduleJob: boolean;
};

export default function RemoveScheduleConfirmationModal({
  show, setOpenFrom, callback, unitId, isScheduleJob, navigate,
}: TypesConfirmModal): JSX.Element {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state: RootState) => state.jobScheduleReducer);
  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const handleClick = () => {
    dispatch(deleteScheduleByIdStart({
      id: unitId, callback, closeModal: setOpenFrom, isScheduleJob, navigate,
    }));
  };
  return (
    <Modal
      open={show}
      onClose={setOpenFrom}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className={styles.deleteIcon}>
          {/* <DeleteModalIcon /> */}
          <img src={warningLogo} alt="Warning" height={100} width={100} />
        </div>
        <div className={styles.modalModalHeading}>
          Are you sure?
        </div>
        <div className={styles.modalModalDescription}>
          Proceeding would remove the saved schedule and reports for this job.
          {isScheduleJob && ' Also this bid will be moved to Unscheduled jobs.'}
        </div>

        <div className={styles.divButtons}>
          <button
            type="button"
            className={`btn ${styles.deleteBtn}`}
            onClick={() => {
              handleClick();
            }}
          >
            Remove
          </button>
          <button type="button" className={`btn ${styles.cancelBtn}`} onClick={setOpenFrom}>Cancel</button>
        </div>
      </Box>
    </Modal>
  );
}
